module.exports = __webpack_public_path__ + "static/media/gf.1f4f4788.svg";